var Popup = function () {
    var plugin_pp_wrapper;
    var show = false;
    let options = {
        delay: 0,
        activeTime: 0,
        device: 1,
        expires: 0,
    }
    var setCookie = function (name, value, minutes) {
        var expires = "";
        if (minutes) {
            var date = new Date();
            date.setTime(date.getTime() + (minutes * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    var removeCookie = function (name) {
        document.cookie = name + '=; Max-Age=-99999999;';
    }

    var getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var handlers = () => {
        $(document).on('click', '.plugin_pp__content_image_wrapper__close, .plugin_pp__content_detailed_wrapper__close', function (e) {
            e.preventDefault();
            hide();
        });
    }

    var deviceOK = function () {
        if (options.device === 3 && window.innerWidth < 992) {
            return true;
        }

        if (options.device === 2 && window.innerWidth > 992) {
            return true;
        }

        if (options.device === 1) {
            return true;
        }

        return false;
    }

    var hide = function () {
        if (show){
            plugin_pp_wrapper.fadeOut(600,function () {
                $(this).remove();
            });
            show = false;
        }
    }
    var showPP = function () {
        if (options.delay > 0) {
            setTimeout(() => {
                if (deviceOK()) {
                    plugin_pp_wrapper.fadeIn(600);
                    show = true;
                    if (options.expires === 1)
                        setCookie('plugin_pp', 'true', 15);
                }
            }, options.delay * 1000);
        }else{
            if (deviceOK()) {
                plugin_pp_wrapper.fadeIn(600);
                show = true;
                if (options.expires === 1)
                    setCookie('plugin_pp', 'true', 15);
            }
        }


    }

    var init = function () {

        if (getCookie('plugin_pp') !== null)
            return;
        $.get('/'+i18n.locale + '/api/v1/ppcontrol', function (data) {
            if (!data.status)
                return;
            $('body').append(data.data);

            plugin_pp_wrapper = $(document).find('.plugin_pp_wrapper')
            options.delay = plugin_pp_wrapper.data('delay') ? plugin_pp_wrapper.data('delay') : 0;
            options.activeTime = plugin_pp_wrapper.data('active-time') ? plugin_pp_wrapper.data('active-time') : 0;
            options.device = plugin_pp_wrapper.data('device') ? plugin_pp_wrapper.data('device') : 1;
            options.expires = plugin_pp_wrapper.data('expires') ? plugin_pp_wrapper.data('expires') : 1;

            showPP();

            if (options.activeTime > 0) {
                setTimeout(() => {
                    hide();
                }, options.activeTime * 1000);
            }




        },'json');

    }



    return {
        init: function () {
            init();
            handlers();
        }
    };
}

$(document).ready(function () {
    setTimeout(() => {
        Popup().init();
    }, 150);
});

